<template>
  <div id="app">
    <div class="container-fluid">
      <nav
        class="navbar fixed-top"
        style="background-color: #1f2122; justify-content: left"
      >
        <h1
          style="
            font-family: 'Anton', sans-serif;
            color: white;
            font-size: 48px;
            margin: 0;
            display: inline;
          "
        >
          <router-link
            to="/"
            style="
              font-family: 'Anton', sans-serif;
              color: #e0e0e0;
              font-size: 48px;
              text-decoration: none;
              cursor: pointer;
            "
          >
            JOSH CURTIS
          </router-link>
        </h1>
        <h2 class="subheader">
          <router-link to="/work" class="sub-link">CODER</router-link>,
          <span
            class="sub-filter"
            :class="{ active: activeFilter === 'adventure' }"
            @click="onFilterClick('adventure')"
          >ADVENTURER</span>,
          <router-link to="/music" class="sub-link">MUSICIAN</router-link>,
          <span
            class="sub-filter"
            :class="{ active: activeFilter === 'motorcycle' }"
            @click="onFilterClick('motorcycle')"
          >MOTORCYCLIST</span>,
          <span
            class="sub-filter"
            :class="{ active: activeFilter === 'creator' }"
            @click="onFilterClick('creator')"
          >CREATOR</span>
        </h2>
      </nav>
      <router-view />
    </div>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #d1d9e0;
  background-color: #1f2122;
}

a,
a:visited,
a:hover,
a:active {
  text-decoration: none;
  color: inherit;
}

.router-link-active,
.router-link-exact-active {
  text-decoration: none;
  color: inherit;
}

.subheader {
  font-family: 'Anton', sans-serif;
  color: #888888;
  padding-left: 20px;
}

.sub-link,
.sub-filter {
  color: #aaaaaa;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.15s ease;
}

.sub-link:hover,
.sub-filter:hover {
  color: #ffffff;
}

.sub-filter.active {
  color: #ffffff;
}
</style>

<script>
import { filterStore, toggleFilter } from "@/store/filterStore";

export default {
  name: "App",
  computed: {
    activeFilter() {
      return filterStore.activeFilter;
    },
  },
  methods: {
    onFilterClick(filter) {
      toggleFilter(filter);
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
  },
};
</script>
